import type { FC, MouseEvent } from 'react';
import React from 'react';

import type { THint } from './models';

export const Hint: FC<React.PropsWithChildren<THint>> = ({ Icon, Tooltip, children, styles }) => {
    const preventEventBubbling = (event: MouseEvent<HTMLElement>) => event.preventDefault();

    return (
        <Tooltip content={children} onClose={preventEventBubbling} onOpen={preventEventBubbling}>
            <button className={styles.button} type="button">
                <Icon />
            </button>
        </Tooltip>
    );
};
